<template>
   <div class="task-list-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("taskList_title") }}</h1>
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2">
                        <UISelectBox :key="$i18n.locale" :label="$t('taskList_filter_lblType')" :options="taskTypes" v-model="searchQuery.type" lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UISelectBox :key="$i18n.locale" :label="$t('taskList_filter_lblStatus')" :options="taskStatuses" v-model="searchQuery.status" lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2
                           :key="$i18n.locale"
                           :label="$t('taskList_filter_lblFromDate')"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date1.max"
                           v-model="searchQuery.date1.value"
                           lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2
                           :key="$i18n.locale"
                           :label="$t('taskList_filter_lblToDate')"
                           :min="searchQuery.date2.min"
                           :max="searchQuery.date2.max"
                           v-model="searchQuery.date2.value"
                           lighter />
                     </div>
                  </div>

                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('common_list')" @click.native="listTasks" />
                     </div>
                  </div>
               </div>
            </div>

            <section class="page-section gts-box" v-if="currentTableOptions.rows.length > 0">
               <GtsGrid :table-options="currentTableOptions" :item-per-page="-1" :title="$t('taskList_title')" />
            </section>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import { taskService } from "@/service/index.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import GtsGrid from "@/components/utils/GtsGrid.vue";
import UIButton from "@/components/unitary/Button.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIDatePicker2 from "@/components/unitary/form2/UIDatePicker2.vue";

export default {
   name: "TaskList",
   components: {
      Main,
      Aside,
      Navbar,
      GtsGrid,
      UIButton,
      UISelectBox,
      UIDatePicker2,
   },
   data() {
      return {
         searchQuery: {
            date1: {
               min: moment().subtract(1, "year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().subtract(1, "month").format(this.$constants.dateFormat),
            },
            date2: {
               min: moment().subtract(1, "year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            type: -1, //ALL
            status: -1, //ALL
         },
         tableOptions: {
            columns: [],
            rows: [],
         },
      };
   },
   computed: {
      taskTypes() {
         return this.$GtsDropdownData.ETaskType(true);
      },
      taskStatuses() {
         return this.$GtsDropdownData.ETaskStatus(true);
      },
      tableColumns() {
         return [
            { label: this.$t("taskList_tblMain_thId") },
            { label: this.$t("taskList_tblMain_thOrderId") },
            { label: this.$t("taskList_tblMain_thType") },
            { label: this.$t("taskList_tblMain_thTaskStatus") },
            { label: this.$t("taskList_tblMain_thOrderStatus") },
            { label: this.$t("taskList_tblMain_thEntityType") },
            { label: this.$t("taskList_tblMain_thEntity") },
            { label: this.$t("taskList_tblMain_thNote") },
            { label: this.$t("taskList_tblMain_thGsa") },
            { label: this.$t("taskList_tblMain_thAgency") },
            { label: this.$t("taskList_tblMain_thCreatedUser") },
            { label: this.$t("taskList_tblMain_thClosingType") },
            { label: this.$t("taskList_tblMain_thUpdatedDateTime") },
         ];
      },
      currentTableOptions() {
         return { ...this.tableOptions, columns: this.tableColumns };
      },
   },
   methods: {
      listTasks() {
         this.tableOptions.rows = [];

         this.$store.commit("app/setIsProgressGifActive", true);

         let request = {
            orderId: 0,
            date1: this.searchQuery.date1.value,
            date2: this.searchQuery.date2.value,
            type: this.searchQuery.type,
            status: this.searchQuery.status,
         };

         taskService.listTasks(request).then((res) => {
            if (!res.result.success) {
               res.result.service = this.$options.name;
               Popup.result(res.result);
               return;
            }

            if (res.result.success) {
               this.$store.commit("app/setIsProgressGifActive", false);
               res.tasks.map((task) => {
                  const rowObj = {
                     id: {
                        iteration: [task.id],
                        className: "order-router gts-animation-scale",
                        router: `/order/detail/${task.orderUuid}?taskopen=true`,
                     },
                     orderId: {
                        iteration: [task.orderId],
                        className: "order-router gts-animation-scale",
                        router: `/order/detail/${task.orderUuid}`,
                     },
                     type: {
                        iteration: [task.type],
                        filter: "ETaskType",
                     },
                     status: {
                        iteration: [task.status],
                        className: "badge",
                        filter: "ETaskStatus",
                     },
                     entityStatus: {
                        iteration: [task.entityStatus],
                        className: "badge",
                        filter: this.handlerEntityType(task.entityType),
                     },
                     entityType: {
                        iteration: [task.entityType],
                        filter: "EOdrEntityType",
                     },
                     entity: task.entityIdentifier,
                     note: task.description,
                     gsa: task.gsaName,
                     agency: task.agencyName,
                     createdUser: {
                        iteration: [task.openedUserEmail, this.$options.filters.FormatterDateTime(task.openedDatetime)],
                     },
                     closingType:
                        task.closingType <= 0
                           ? ""
                           : {
                                iteration: [task.closingType],
                                className: "badge",
                                filter: "ETaskClosingType",
                             },
                     updatedDateTime: this.$options.filters.FormatterDateTime(task.updatedDatetime),
                     tags: JSON.stringify(task),
                  };
                  this.tableOptions.rows.push(rowObj);
               });
            }
         });
      },
      handlerEntityType(entityType) {
         switch (entityType) {
            case 1: //PAYMENT
               return "EPayPaymentStatus";
            case 2: //PNR
               return "EFltPnrStatus";
            case 3: //VOUCHER
               return "EHtlVoucherStatus";
            case 4: //TNR
               return "ETrfTnrStatus";
            case 5: //RNR
               return "ERacRnrStatus";
            case 6: //INVOICE
               return "EInvoiceStatus";
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.page-container {
   .page-inner {
      width: 90%;
      margin: auto;
      .page-form-row {
         display: grid;
         grid-template-columns: repeat(6, 1fr);
         grid-column-gap: 1rem;
      }
      .page-action-row {
         margin-top: 1rem;
         display: flex;
         justify-content: flex-end;
      }
   }
}
</style>
